import { useContext, useState } from "react";
import shortid from "shortid";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext";
import { api, phoneMask } from "../../../helpers";
import { Button, IconGoogle, Link } from "../../atoms";
import { Dialog } from "../Dialog";
import QRCode from "qrcode";
import {
  DetailsTable,
  EmptyTable,
  EmptyTableWrapper,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Wrapper,
} from "./styles";
import formatTelefone from "../../../helpers/formatTelefone";
// const QRCode: any = require("qrcode");

export const geraVoucher = async (ids: number[]) => {
  let htmlContent = `
  <!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Voucher</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        padding: 20px;
        background-color: #f9f9f9;
      }
      h1 {
        color: #333;
      }
      td {
        width:250px;
        text-align:left;
      }
      th {
         text-align:left;
         border-top: 2px solid #000; /* Barra acima */
         border-bottom: 2px solid #000; /* Barra abaixo */
         text-align: left;
      
      }
      @media print {
        button {
          display: none;
        }
      }
    </style>
  </head>
  <body>
  `;

  for (const id of ids) {
    console.error(id);
    const {
      data: [reserva],
    } = await api.get(`/api/reservas/search/codigo/${id}/codigo`);

    const {
      data: { Registros },
    } = await api.post(`/api/reserva/passageiros`, {
      codigoreserva: id,
      limit: 10,
      offset: 0,
    });

    const qrCodeURL = await QRCode.toDataURL(
      "https://translados.azurewebsites.net/operacional/baixareserva?codigoReserva=" +
        reserva.reserva,
    );
    console.warn(qrCodeURL);
    // Cria o conteúdo do HTML

    htmlContent += `
  
    <div style=\"width: 750px;  border: solid 1px gainsboro\">
    <div><img alt=\"BioTur\" src=\"https://translados.azurewebsites.net/assets/img/logoBiotur.jpg\" style=\"width: 200px;\" /></div>
    <img style=\"-webkit-user-select: none; float:right; display:block; margin-left: auto; margin-right: auto;position: relative; left: -70px;top: 180px; width: 200px;\" src=${qrCodeURL}>

<div align=\"center\" style=\"font-family: Calibri; font-weight: bold; font-size: 22px;color: Black\">Bilhete de Embarque – Catamarãs Biotur

<div style=\"width: 750px; font-size: 13px; font-family: Verdana; font-weight: normal\"><br />É necessario antes do embarque em Salvador, A realização do check in no guichê. Em Morro de São Paulo, o mesmo será realizado na
entrada do catamarã. OBSERVACAO: Em seu retorno é importante respeitar um tempo MINIMO de 6:00 para o horarios do voo, pois este serviço poderá ser realizado via SEMI TERRESTRE por conta do mau tempo  <br /><br /></div></div>
<table style=\"left:30px;\">
<tr><td style=\"font-weight: bold; width:200px;\">&nbsp;&raquo;&nbsp;Nº Recibo:</td><td>${
      reserva.reserva
    }<br /></td></tr>
    <tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Saída:</td><td style=\"font-weight: bold\">${
      reserva.embarque
    }<br /></td></tr>
    <tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Data Reserva:</td><td>${
      reserva.data_reserva
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Vendedor:</td><td>${
      reserva.cliente
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Origem:</td><td>${
      reserva.origem
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Destino:</td><td>${
      reserva.destino
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Transporte:</td><td>${
      reserva.barco
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Nº de Pessoas:</td><td>${
      reserva.adultos + reserva.criancas
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Filial:</td><td>${
      reserva.nomefilial
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;R$ Unitario:</td><td>${
      reserva.preco
    }<br /></td></tr> 

<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;TPP:</td><td>${
      reserva.agerba
    }<br /></td></tr>
<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Taxa de Embarque:</td><td>${
      reserva.taxa_embarque
    }<br /></td></tr>
  


<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;R$ Total:</td><td>${
      reserva.valor_total
    }<br /></td></tr>

<tr><td style=\"font-weight: bold\" width=\"200px\">&nbsp;&raquo;&nbsp;Passageiros:</td><td style=\"font-weight: bold\">${reserva.adultos} ADULTOS,  ${reserva.criancas}  CRIANCAS<br /></td></tr>
</table>

<table>
<thead>
  <tr>
    <th>ID</th>
    <th>Nome</th>
    <th>Telefone</th>
    <th>ADL/CHD</th>
  </tr>
</thead>
${Registros.map(
  (item: { id: number; Nome: string; Telefone: string; Tipo: string }) =>
    `<tr>
    <td style="width:20px">${item.id}</td>
    <td style="width:320px">${item.Nome}</td>
    <td style="width:200px">${formatTelefone(item.Telefone)}</td>
    <td style="width:20px">${item.Tipo}</td>
  </tr>`,
)}
</table>
</div>


</td></tr>



<tr><td style=\"font-weight: bold\" width=\"130px\"><br /><br />&nbsp;&raquo;&nbsp;Local do embarque:${
      reserva.localembarque
    }<br /><br /></td></tr>

<div id=\"marcadagua\" style=\"z-index: -1; position: absolute; top: 540px;left: 45px;width: 705px;background-image: URL(https://translados.azurewebsites.net/assets/img/marcadagua.jpg); background-size: cover; height: 261px;\" id=\"marcadagua\"> </div>

<tr><td style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\" width=\"750px\">&nbsp;&raquo;&nbsp;OBSERVAÇÕES:</td></tr>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />1º TORNA-SE OBRIGATORIO A APRESENTAÇÃO DESTE BILHETE NO LOCAL DE EMBARQUE.<br /></div></div>
<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />2º Estes serviços poderão sofrer possiveis atrasos, assim, não nos responsabilizamos por perdas de vôos.<br /></div></div>
<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />3º O passageiro deverá comparecer ao Guichê da Biotur com antecedência mínima de 30 minutos munido do documento de identidade e deste voucher.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />4º Em caso de desistência, comparecer ao local onde efetuou a compra, com antecedência mínima de 24hs do horário para o embarque, caso contrário, o reembolso não será concedido.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />5º Em caso de reembolso será deduzido do valor da passagem uma multa de 20%.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />6º A remarcação desse bilhete poderá ocorrer somente com até 24 horas antes da saída da embarcação, conforme compra realizada,mediante a disponibilidade de vagas e será cobrado uma taxa de R$20,00 por bilhete.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />7º Em caso de mau tempo ou problemas mecânicos na embarcação, a viagem poderá ser realizada VIA TERRESTRE, com duração aproximada de 04:20 (quatro horas e vinte minutos).<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />8º Crianças a partir de seis anos de idade pagam passagem normal.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />9º O transporte de animais domésticos de pequeno porte e cães guias só é permitido com focinheira ou caixa para transporte.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />10º Não nos responsabilizamos por perda, roubo e/ou extravio deste voucher.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />11º Reembolsos para pagamento em cartões de crédito são de acordo à política da administradora do cartão do cliente.<br /></div></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal\"><br />12º INFORMAMOS AOS NOSSOS CLIENTES E AMIGOS QUE PROCUREM AGÊNCIAS CREDENCIADAS PARA A COMPRA DOS SEUS BILHETES.<br /></div>

<div style=\"width: 750px; font-size: 10px; font-family: Verdana; font-weight: normal; text-align:center\">
<br /><br />
<hr>
<a href="http://www.biotur.com.br" target="_blank" style="text-decoration: none; color: inherit;">www.biotur.com.br</a>&nbsp;|&nbsp;
<a href="mailto:contato@biotur.com.br" style="text-decoration: none; color: inherit;">contato@biotur.com.br</a>
<br />
Copyright &copy; <script>document.write(new Date().getFullYear());</script> - Biônica Transporte e Turismo Marítimo Ltda
<br />
75-99986-3620
</div>


</div>
`;
  }

  htmlContent += "<button onclick='window.print()'>Imprimir</button>";
  // Abre uma nova aba e escreve o HTML nela
  const novaAba = window.open("", "_blank");
  novaAba?.document.open();
  novaAba?.document.write(htmlContent);
  novaAba?.document.close();
};
export interface RowContract {
  [key: string]: any | Object;
}

type TableProps = {
  data: RowContract[];
  onClick: (data: RowContract[]) => void;
};

export function TableReservas({ data, onClick }: TableProps) {
  const { applicationData } = useContext(AuthContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [idExclusao, setIdExclusao] = useState<number | null>(null);

  interface Registros1 {
    id: number;
    Nome: string;
    Celular: string;
    Tipo: string;
  }

  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const excluir = async (id: number) => {
    const response = await api.delete(
      `/api/reserva/${applicationData.funcionario}/${id}`,
    );
    if (response.data.statuscode === 200) {
      data = data.filter((item) => {
        return item.Codigo !== id;
      });
      setType("success");
      setTextAlert(response.data.message);
      setShow(true);
      onClick(data);
    }
  };

  /*  const geraVoucher = async (id: number) => {
    const { data: pdf } = await api.post("/api/printreserva", id, {
      responseType: "blob"
    })

    let alink = document.createElement("a")
    alink.href = window.URL.createObjectURL(pdf)
    alink.download = "voucher.pdf"
    alink.click()
  }
*/

  const tableHead =
    Object.keys(data).length > 0 ? [...Object.keys(data[0]), "Ação"] : [];

  const tableBody =
    Object.keys(data).length > 0
      ? data.map((row, index) => {
          const newRow = [];
          for (const key in row) {
            if (tableHead.includes(key))
              newRow.push(
                <TableCell key={shortid.generate()}>{row[key]}</TableCell>,
              );
          }
          newRow.push(
            <TableCell key={shortid.generate()}>
              <Link to={"/operacional/passageiros/" + row["Codigo"]}>
                Passageiro
              </Link>
            </TableCell>,
          );
          newRow.push(
            <TableCell key={shortid.generate()}>
              <Button
                appearance="success"
                onClick={() => {
                  setOpenDialog(false);
                  geraVoucher([row["Codigo"]]);
                }}
              >
                Voucher
              </Button>
            </TableCell>,
          );
          newRow.push(
            <TableCell key={shortid.generate()}>
              {applicationData.acesso === "funcionario" ? (
                <Button
                  appearance="danger"
                  onClick={() => {
                    setOpenDialog(true);
                    setIdExclusao(row["Codigo"]);
                  }}
                >
                  Excluir
                </Button>
              ) : null}
            </TableCell>,
          );
          return newRow;
        })
      : [[]];

  return (
    <>
      {Object.keys(data).length > 0 ? (
        <Wrapper>
          <DetailsTable className="table table-striped">
            <TableHeader>
              <TableRow>
                {tableHead.map((columnName) => (
                  <TableColumn key={shortid.generate()}>
                    {columnName}
                  </TableColumn>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableBody.map((row) => (
                <TableRow key={shortid.generate()}>
                  {row.map((tCell) => tCell)}
                </TableRow>
              ))}
            </TableBody>
          </DetailsTable>
        </Wrapper>
      ) : (
        <EmptyTableWrapper>
          <EmptyTable>
            <IconGoogle>error_outline</IconGoogle> Não encontramos nenhum
            registro para apresentação.
          </EmptyTable>
        </EmptyTableWrapper>
      )}
      <Dialog
        open={openDialog}
        title="Confirmação de exclusão"
        description="Confirma exclusão do registro?"
        onShow={(action) => {
          setOpenDialog(action === "opened");
        }}
        actions={
          <>
            <Button
              appearance="success"
              autoFocus
              onClick={(e) => {
                excluir(idExclusao!);
                setOpenDialog(false);
              }}
            >
              Confirmar
            </Button>
          </>
        }
      />
    </>
  );
}
